/**
 * Custom wrapper around ApplicationInsights for standardizing
 * responses.
 */
export default class CustomApplicationInsights {
    /**
     * Create a new CustomApplicationInsights instance.
     */
    constructor(appInsights) {
        this._appInsights = appInsights;
    }
    /**
     * Attempt to gracefully track an arbitrary error or exception input.
     */
    trackException(error, customProperties) {
        if (error.exception !== undefined) {
            //we've already converted this elsewhere
            this._appInsights.trackException(error, customProperties);
        }
        else if (error instanceof Error) {
            this._appInsights.trackException({
                exception: error,
            }, customProperties);
        }
        else if (error instanceof String) {
            this._appInsights.trackException({
                exception: new Error(error),
            }, customProperties);
        }
        else {
            this._appInsights.trackEvent({
                name: 'Not handling error of type ' + typeof error,
            }, customProperties);
            // We don't know what it is, so err on the safe side and log it anyways.
            this._appInsights.trackException(error, customProperties);
        }
    }
    /**
     * Log a user action or other occurrence.
     */
    trackEvent(event, customProperties) {
        this._appInsights.trackEvent(event, customProperties);
    }
}
